/* eslint-disable jsx-a11y/anchor-is-valid */
const Link = () => {
    return (
        <a className="link" onClick={(e) => e.preventDefault()}>
            <button>
                <span className="link-name">Link</span>
            </button>
        </a>
    );
};

export default Link;
